import Auth from "areas/auth/ui/Auth";


export default function Login() { return <Auth.Login />; }